import TextProfileImage from "./testProfileImage.png";
import { tw } from "@/utils";

export const Profile = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex items-center gap-[12px]">
        <div
          className={tw(
            "relative w-[44px] h-[44px] shrink-0",
            "border-solid border-[0.5px] border-gray-g75 rounded-full"
          )}
        >
          <img
            className="w-full h-full object-cover rounded-full"
            src={TextProfileImage}
          />
          <div
            className={tw(
              "absolute w-[12px] h-[12px] right-0 bottom-0",
              "flex items-center justify-center bg-white rounded-full"
            )}
          >
            <div className="w-[8px] h-[8px] bg-green rounded-full"></div>
          </div>
        </div>
        <div className="w-[148px] h-full">
          <div
            className={tw(
              "w-full h-[28px] text-gray-g300 font-semibold text-lg leading-[28px]",
              "text-nowrap overflow-hidden text-ellipsis"
            )}
          >
            경북대학교병원
          </div>
          <div
            className={tw(
              "w-full h-[14px] text-gray-g100 font-medium text-sm leading-[14px]",
              "text-nowrap overflow-hidden text-ellipsis"
            )}
          >
            응급의학과
          </div>
        </div>
      </div>
    </div>
  );
};
